<div #mouseArea
     (dragstart)="false"
     (mousedown)="mouseDown($event)"
     (mousemove)="mouseMove($event)"
     (mouseout)="mouseUp($event)"
     (mouseup)="mouseUp($event)"
     container>
  <div #hslWheel [style]="styleForHslWheel" hslwheel>
    <div #imageBox [style]="styleForHsl" inner>
      <div image>
        <canvas #canvasHSL></canvas>
      </div>
    </div>
    <div [style]="styleForHuePointerBox" pointer-box>
      <div [style]="styleForHuePointer" pointer>
        <div hue-pointer-back></div>
        <div [style]="styleForHuePointerFore" hue-pointer-fore></div>
      </div>
      <div [style]="styleForHslPointer" pointer>
        <div mark></div>
      </div>
    </div>
  </div>
  @if (color?.type !== 'rgb') {
    <div #opcBar [style]="styleForOpcBack" opc-back>
      <div opc-fore></div>
      <div [style]="styleForOpcPointer" pointer vert>
        <div mark></div>
      </div>
    </div>
  }
</div>
@if (globals.isDebug) {
  <div class="debug" info>
    <div>
      H: {{ floor(hue) }}
      S: {{ floor(sat) }}
      L: {{ floor(light) }}
    </div>
    <div>
      O: {{ floor(opacity * 100) }}%
    </div>
    <div>
      #: {{ color.display_rgba }}
    </div>
  </div>
}
